import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { verifyEmail } from '../../actions/emailVerification'

import { LoadingOutlined } from '@ant-design/icons'

class VerifyEmail extends Component {
    state = {
      beforeAction: true,
    }

    componentDidMount() {
      this.props.actions.verifyEmail(this.props.match.params.token)
      this.setState({
        beforeAction: false,
      })
    }

    render() {
      const { isVerifying, errorMessage } = this.props
      const { beforeAction } = this.state
      // show loading symbol before using action and while verifying token
      if (beforeAction || isVerifying) {
        return <LoadingOutlined className='loading' />
      }
      // now check if failure or success
      if (errorMessage) {
        return (<Redirect
                to={{
                  pathname: '/login',
                  state: { error: errorMessage },
                }}
            />)
      }
      // successfully verified, send to login page
      return (<Redirect
            to={{
              pathname: '/login',
              state: { success: 'You have successfully verified your email address.' },
            }}
        />)
    }
}

function mapStateToProps(state) {
  return {
    isVerifying: state.emailVerification.isVerifying,
    errorMessage: state.emailVerification.errorMessage,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ verifyEmail }, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmail)
